
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";

interface ImageFieldProps {
  form: UseFormReturn<any>;
}

export const ImageField: React.FC<ImageFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="image_url"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Image URL</FormLabel>
          <FormControl>
            <Input {...field} placeholder="https://example.com/image.jpg" />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
